<template>
  <div class="app-container">
    <el-form :model="search" :inline="true" label-position="right">
      <!-- a. 货场编码，精准搜索 -->
      <el-form-item label="货场编码" prop="goodsYardCode">
        <el-input
          v-model="search.goodsYardCode"
          placeholder="请输入"
          clearable
        ></el-input>
      </el-form-item>

      <!-- b. 分公司，下拉多选 -->
      <el-form-item label="分公司" prop="orgIds">
        <el-select
          v-model="search.orgIds"
          multiple
          placeholder="请选择"
          :disabled="this.partnershipType !== 3"
          clearable
        >
          <el-option
            v-for="item in managementOptions"
            :key="item.partnershipId"
            :label="item.partnerName"
            :value="item.partnershipId"
            style="width: 100%"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <!-- c. 货场主名称，模糊搜索 -->
      <el-form-item label="货场主名称" prop="goodsYardUser">
        <el-input
          v-model="search.goodsYardUser"
          placeholder="请输入"
          clearable
        ></el-input>
      </el-form-item>

      <!-- d. 货场联系电话，精准搜索 -->
      <el-form-item label="货场联系电话" prop="goodsYardPhone">
        <el-input
          v-model="search.goodsYardPhone"
          placeholder="请输入"
          clearable
        ></el-input>
      </el-form-item>

      <!-- e. 省市区选择 -->
      <el-form-item label="省" prop="provinceCode">
        <el-select
          v-model="search.provinceCode"
          placeholder="请选择"
          clearable
          style="width: 100%"
          @change="provinceChangeFun"
        >
          <el-option
            v-for="item in provinceList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
            style="width: 100%"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="市" prop="cityCode">
        <el-select
          v-model="search.cityCode"
          placeholder="请选择"
          clearable
          style="width: 100%"
          @change="cityChangeFun"
          :disabled="!search.provinceCode"
        >
          <el-option
            v-for="item in cityList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
            style="width: 100%"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="区" prop="districtCode">
        <el-select
          v-model="search.districtCode"
          placeholder="请选择"
          clearable
          style="width: 100%"
          :disabled="!search.cityCode"
        >
          <el-option
            v-for="item in districtList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
            style="width: 100%"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <!-- f. 提交时间，年月日区间 -->
      <el-form-item label="提交时间" prop="submitTime">
        <el-date-picker
          v-model="submitTime"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
          clearable
        ></el-date-picker>
      </el-form-item>

      <!-- g. 更新时间，年月日区间 -->
      <el-form-item label="更新时间" prop="updateTime">
        <el-date-picker
          v-model="updateTime"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
          clearable
          style="width: 100%"
        ></el-date-picker>
      </el-form-item>

      <!-- h. 提交人，模糊搜索 -->
      <el-form-item label="提交人" prop="createdByName">
        <el-input
          v-model="search.createdByName"
          placeholder="请输入"
          clearable
        ></el-input>
      </el-form-item>
    </el-form>

    <el-row class="row">
      <el-col :span="8">
        <el-button type="primary" size="medium" @click="handleSearch()"
          >查询</el-button
        >
        <el-button size="medium" @click="resetForm">重置</el-button>

        <el-button size="medium" @click="exportExcel" :loading="exportFlag"
          >导出</el-button
        >
      </el-col>
    </el-row>

    <el-table :data="list" center height="60vh">
      <el-table-column label="操作" fixed="left" width="150" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="goDetail(scope.row.id)"
            >查看</el-button
          >
          <el-button type="text" @click="goEdit(scope.row)">编辑</el-button>
          <el-button type="text" @click="delItem(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>

      <el-table-column
        prop="goodsYardCode"
        label="货场编码"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="orgName"
        label="分公司"
        width="150"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="goodsYardUser"
        label="货场主名称"
        align="center"
        width="150"
      ></el-table-column>
      <el-table-column
        prop="goodsYardPhone"
        label="货场联系电话"
        width="150"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="provinceName"
        label="省"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="cityName"
        label="城"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="districtName"
        label="区"
        width="150"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="townName"
        label="街道"
        align="center"
        width="150"
      ></el-table-column>
      <el-table-column
        prop="address"
        label="详细地址"
        align="center"
        width="250"
      ></el-table-column>
      <el-table-column
        prop="createdByName"
        label="提交人"
        align="center"
        width="150"
      ></el-table-column>
      <el-table-column
        prop="submitTime"
        label="提交时间"
        align="center"
        width="150"
      ></el-table-column>
      <el-table-column
        prop="updateTime"
        label="更新时间"
        align="center"
        width="150"
      ></el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes,prev, pager, next,jumper"
        :current-page.sync="search.page"
        :page-size="search.size"
        :page-sizes="[10, 20]"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {
  getYardList,
  exportList,
  delGoodsyard,
  getManagementList,
} from "@/api/goodsYard";
import jdProvinceCity from "../jdOldMachineRecycleManage/mixins/jdProvinceCity";
import mixin from "./mixin";

import {
  getPartnerList,
  findAllProvince,
  findAllCity,
  findAllCounty,
} from "@/api/COldForNew";

export default {
  name: "yardManagement",
  mixins: [jdProvinceCity, mixin],
  data() {
    return {
      partnershipType: null, //当前用户所属组织 1 子公司 2 第三方 3 总公司

      list: [],
      total: 0,
      submitTime: [],
      updateTime: [],
      search: {
        page: 1,
        size: 10,
        goodsYardCode: "", // 货场编码
        orgIds: [], // 机构
        goodsYardUser: "", // 货场主姓名
        goodsYardPhone: "", // 货场联系电话
        provinceCode: "", // 省份code
        cityCode: "", // 城市code
        districtCode: "", // 区县code
        submitTimeStart: "", //提交开始时间
        submitTimeEnd: "", //提交结束时间
        lastModifiedDateStart: "", //最后修改开始时间
        lastModifiedDateEnd: "", //最后修改结束时间
        createdByName: "", // 创建人名
      },
      currOrgId: "", //当前分公司的组织 id
      managementOptions: [], //分公列表
      exportFlag: false,
    };
  },
  computed: {},
  created() {
    this.partnershipType = JSON.parse(localStorage.getItem("partnershipType"));
    this.getManagementOptions();
  },
  mounted() {
    this.getList();
  },
  methods: {
    init() {},
    async getManagementOptions() {
      const params = {
        partnershipType: 1,
        pageNum: 1,
        pageSize: 999,
      };
      let { statusCode, data } = await getManagementList(params);
      if (statusCode == 200) {
        this.managementOptions = data.records;
        if (this.partnershipType == 1 && this.managementOptions.length == 1) {
          this.currOrgId = this.managementOptions[0].partnershipId;
          this.search.orgIds.push(this.managementOptions[0].partnershipId);
        }
      }
    },
    handleSizeChange(val) {
      this.search.page = 1;
      this.search.size = val;
      this.getList();
    },
    resetForm() {
      this.search = this.$options.data().search;
      if (this.partnershipType == 1) {
        this.search.orgIds.push(this.currOrgId);
      }
      this.submitTime = this.updateTime = [];
    },
    handleCurrentChange() {
      this.getList();
    },
    handleSearch() {
      this.search.page = 1;
      this.getList();
    },
    async getList() {
      if (this.submitTime.length === 2) {
        this.search.submitTimeStart = this.submitTime[0];
        this.search.submitTimeEnd = this.submitTime[1];
      } else {
        this.search.submitTimeStart = "";
        this.search.submitTimeEnd = "";
      }

      if (this.updateTime.length === 2) {
        this.search.lastModifiedDateStart = this.updateTime[0];
        this.search.lastModifiedDateEnd = this.updateTime[1];
      } else {
        this.search.lastModifiedDateStart = "";
        this.search.lastModifiedDateEnd = "";
      }

      let { statusCode, data, total } = await getYardList(this.search);
      if (statusCode != 200) {
        return;
      }

      this.list = data;
      this.total = total;
    },
    goDetail(id) {
      this.$router.push({
        name: "/dataBoard/goodsYardDetail",
        query: {
          id: id,
        },
      });
    },
    goEdit(rowData) {
      this.$router.push({
        name: "/dataBoard/goodsYardEdit",
        query: {
          id: rowData.id,
        },
      });
    },
    //导出

    async exportExcel() {
      this.exportFlag = true;

      this.global
        .exportExcel(
          `/autoapp-default-server-recovery/api/goodsyard/pc/exportList`,
          this.search,
          "货场信息"
        )
        .then(() => {
          // 导出成功后处理逻辑
        })
        .catch((res) => {
          console.log(res);
        })
        .finally(() => {
          this.exportFlag = false;
        });
    },
    async delItem(id) {
      this.$confirm("确认删除该货场?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info",
      }).then(async () => {
        delGoodsyard(id).then((res) => {
          if (res.statusCode == 200) {
            this.getList();
            this.$message({
              type: "success",
              message: "删除成功!",
            });
          }
        });
      });
    },
    // 省改变
    provinceChangeFun() {
      this.search.cityCode = undefined;
      this.search.districtCode = undefined;
      const provinceCode = this.search.provinceCode;
      this.getTblCity(provinceCode);
    },
    // 市改变
    cityChangeFun() {
      this.search.districtCode = undefined;
      const cityCode = this.search.cityCode;
      this.getTblCounty(cityCode);
    },
  },
};
</script>

<style scoped lang="scss">
.row {
  margin-bottom: 15px;
}
.el-date-editor.el-input {
  width: 168px;
}
</style>



// WEBPACK FOOTER //
// src/views/dataBoard/goodsYard.vue